module.exports = __webpack_public_path__ + "static/media/icons_Bilan Respiratoire adulte - libre.a01ccc55.svg";